module.exports = __webpack_public_path__ + "screen_hello-d08d3eac890211eaa3ae6d75639787dd.svg";